import React, { Suspense, lazy } from "react";
import { Route, Redirect } from "react-router-dom";
import { HOME_PAGE_PATH } from "../constants/NavigationConstants";
import { ACCESS_TOKEN } from "./tokenUtils";

const LoadingModal = lazy(() => import("../components/LoadingModal"));

function PublicRoute({ component: Component, ...rest }) {
  let token = localStorage.getItem(ACCESS_TOKEN) || null;
  return (
    <Suspense fallback={<LoadingModal />}>
      <Route
        {...rest}
        render={props =>
          !token ? (
            <Component {...props} />
          ) : (
            <Redirect to={{ pathname: HOME_PAGE_PATH }} />
          )
        }
      />
    </Suspense>
  );
}

export default PublicRoute;
